// Actions
import {SET_TOKEN} from 'isee/redux/session/actions';

// Vendor Types
import {Reducer} from 'redux';

export type State = string | null;

const initialState: State = null;

export const reducer: Reducer<State> = (state = initialState, action) => {
  const {type, payload} = action;
  return type === SET_TOKEN ? payload : state;
};



// WEBPACK FOOTER //
// ./src/redux/session/reducer.ts